define("shared/components/shared/ui/social-profile-switcher", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <BasicDropdown as |emberDrop|>
    <emberDrop.Trigger @htmlTag="span" data-test-id="social-profile-switcher-trigger">
      <div class="o--btn o--btn--outline o--btnDrop o--page__switcher qa--profile_switcher" {{did-insert this.setup}}>
        {{#if @selectedLinkinbioPage}}
          <Shared::Ui::SocialProfileSwitcher::Linkinbio::PageAvatar
            @avatarClass="qa--top_nav_avatar"
            @handleQaClass="qa--top_nav_ig_handle"
            @linkinbioPage={{@selectedLinkinbioPage}}
            @socialProfile={{@selectedLinkinbioPage.instagramProfile}}
          />
        {{else}}
          <Shared::ProfileAvatar
            @avatarClass="qa--top_nav_avatar"
            @handleQaClass="qa--top_nav_ig_handle"
            @showDetails={{true}}
            @socialProfile={{@selectedProfile}}
          />
        {{/if}}
        {{svg-jar "caret-down" class="o--icon o--btnDrop__icon o--page__switcherIcon"}}
      </div>
    </emberDrop.Trigger>
    <emberDrop.Content data-test-id="social-profile-switcher-content">
      <Shared::Ui::SocialProfileSwitcher::List
        @areUpgradableProfilesUnswitchable={{@areUpgradableProfilesUnswitchable}}
        @linkinbioPages={{@linkinbioPages}}
        @onChange={{this.onChange}}
        @selectedLinkinbioPage={{@selectedLinkinbioPage}}
        @selectedProfile={{@selectedProfile}}
        @switchableProfiles={{@switchableProfiles}}
        @unswitchableProfiles={{this.unswitchableProfiles}}
        @upgradableProfiles={{@upgradableProfiles}}
        @upgradeText={{this.upgradeText}}
        {{on "click" emberDrop.actions.close}}
      />
    </emberDrop.Content>
  </BasicDropdown>
  */
  {
    "id": "0N9Aljcz",
    "block": "[[[8,[39,0],null,null,[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"Trigger\"]],[[24,\"data-test-id\",\"social-profile-switcher-trigger\"]],[[\"@htmlTag\"],[\"span\"]],[[\"default\"],[[[[1,\"\\n    \"],[11,0],[24,0,\"o--btn o--btn--outline o--btnDrop o--page__switcher qa--profile_switcher\"],[4,[38,1],[[30,0,[\"setup\"]]],null],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"        \"],[8,[39,3],null,[[\"@avatarClass\",\"@handleQaClass\",\"@linkinbioPage\",\"@socialProfile\"],[\"qa--top_nav_avatar\",\"qa--top_nav_ig_handle\",[30,2],[30,2,[\"instagramProfile\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,4],null,[[\"@avatarClass\",\"@handleQaClass\",\"@showDetails\",\"@socialProfile\"],[\"qa--top_nav_avatar\",\"qa--top_nav_ig_handle\",true,[30,3]]],null],[1,\"\\n\"]],[]]],[1,\"      \"],[1,[28,[35,5],[\"caret-down\"],[[\"class\"],[\"o--icon o--btnDrop__icon o--page__switcherIcon\"]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[8,[30,1,[\"Content\"]],[[24,\"data-test-id\",\"social-profile-switcher-content\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[39,6],[[4,[38,7],[\"click\",[30,1,[\"actions\",\"close\"]]],null]],[[\"@areUpgradableProfilesUnswitchable\",\"@linkinbioPages\",\"@onChange\",\"@selectedLinkinbioPage\",\"@selectedProfile\",\"@switchableProfiles\",\"@unswitchableProfiles\",\"@upgradableProfiles\",\"@upgradeText\"],[[30,4],[30,5],[30,0,[\"onChange\"]],[30,2],[30,3],[30,6],[30,0,[\"unswitchableProfiles\"]],[30,7],[30,0,[\"upgradeText\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"emberDrop\",\"@selectedLinkinbioPage\",\"@selectedProfile\",\"@areUpgradableProfilesUnswitchable\",\"@linkinbioPages\",\"@switchableProfiles\",\"@upgradableProfiles\"],false,[\"basic-dropdown\",\"did-insert\",\"if\",\"shared/ui/social-profile-switcher/linkinbio/page-avatar\",\"shared/profile-avatar\",\"svg-jar\",\"shared/ui/social-profile-switcher/list\",\"on\"]]",
    "moduleName": "shared/components/shared/ui/social-profile-switcher.hbs",
    "isStrictMode": false
  });

  let SocialProfileSwitcherComponent = (_class = class SocialProfileSwitcherComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "router", _descriptor3, this);
    }

    get socialProfiles() {
      return this.auth.currentGroup.socialProfiles;
    }

    get socialProfile() {
      return this.args.selectedProfile;
    }

    get linkinbioPage() {
      return this.args.selectedLinkinbioPage;
    }

    get unswitchableProfiles() {
      if (!this.socialProfiles || !this.args.switchableProfiles) {
        return [];
      }

      if (this.args.unswitchableProfiles) {
        return this.args.unswitchableProfiles;
      }

      return this.socialProfiles.filter(socialProfile => !this.args.switchableProfiles.find(switchableProfile => switchableProfile.id === socialProfile.id));
    }

    get upgradeText() {
      return this.args.upgradeText || this.intl.t('shared_phrases.available_for_starter_and_up');
    }

    get isOnLinkinbioAnalytics() {
      return this.router.currentRouteName?.includes('linkinbio.overview');
    }

    async setup() {
      await this.auth.setSocialProfile(this.socialProfile);

      if (this.isOnLinkinbioAnalytics && typeof this.args.onChange === 'function') {
        this.args.onChange(this.socialProfile, await this.linkinbioPage);
      }
    }

    async onChange(socialProfile, linkinbioPage) {
      if (typeof this.args.onChange === 'function') {
        this.args.onChange(socialProfile, linkinbioPage);
      }

      await this.auth.setSocialProfile(socialProfile);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype)), _class);
  _exports.default = SocialProfileSwitcherComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialProfileSwitcherComponent);
});